import { useFpCampaignProductsService } from '@cart-services/hooks/useFpCampaignProductsService'
import { type CountryCode, type ProjectCode } from '@constants'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useRef } from 'react'
import { TheCampaignHeader } from '../../components/TheCampaignHeader'
import style from '../../style/pages/client-contact.module.scss'
import { loadContactClientData } from '../client-data-import'
import { useProductCatalog } from './product-catalog/components/ProductCatalogProvider/useProductCatalog'

const ClientContact = () => {
  const { campaignCode } = useProductCatalog()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCode)
  const campaignId = exhibitorSettings?.campaign_id ?? undefined
  const { region: countryCode } = exhibitorSettings || {}
  const { projectCode } = useFpCampaignProductsService(campaignCode)
  const country = exhibitorSettings?.region.toLowerCase() || 'hk'
  const contact = useRef<Contact.ContactData>(loadContactClientData(country))

  return (
    <main className={style.main}>
      <TheCampaignHeader projectCode={projectCode as ProjectCode} campaignId={campaignId as number} countryCode={countryCode as CountryCode} />
      <div className={style['contact-wrapper']}>
        <div className={style['main-title']}>{contact.current?.mainTitle}</div>
        {contact.current?.mainContent.map(item => (
          <div key={item.title}>
            <div className={style.title}>{item.title}</div>
            <div
              className={style.content}
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          </div>
        ))}
      </div>
    </main>
  )
}

export default ClientContact
